import { Grid, List, ListItem, ListItemText } from '@mui/material';
import React from 'react';
import { TableProps } from './RootineTable';
import { RootineTableColumn } from './RootineTableColumn';
import { RootineTableRow, RowProps } from './RootineTableRow';

export const RootineMobileTable = (props: TableProps): JSX.Element => {
  const handleClick = (idx: number) => {
    if (props.onClick) {
      props.onClick(idx);
    }
  };

  let columnKeys = Object.keys(props.columns);

  columnKeys = columnKeys.sort((c1, c2) => {
    const c1SortOrder = props.columns[c1].mobileSortOrder;
    const c2SortOrder = props.columns[c2].mobileSortOrder;
    if (!c1SortOrder || !c2SortOrder) return 0;
    return c1SortOrder - c2SortOrder;
  });

  return (
    <List
      sx={{
        backgroundColor: props.primaryColor || 'white',
        padding: '0',
        maxHeight: { xs: props.maxHeightMobile, md: props.maxHeight || 400 },
        overflow: 'scroll',
        borderTop: 10,
        borderTopColor: props.secondaryColor || '#F8F8F8',
      }}
    >
      {props.rows &&
        props.rows?.length > 0 &&
        props.rows.map((row: { [name: string]: RowProps }, i: number) => {
          return (
            <ListItem
              key={i}
              divider
              alignItems="flex-start"
              onClick={(e) => handleClick(i)}
              sx={{
                border: `10px solid ${props.secondaryColor || '#F8F8F8'}`,
                borderTop: 0,
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                sx={{ width: '100%' }}
              >
                {columnKeys.map((field: string, i: number) => {
                  // if there are odd number, allow last one to fill horizontal
                  const fillHorizontal =
                    (i + 1) % 2 === 1 && i === columnKeys.length - 1;
                  return (
                    <Grid
                      item
                      container
                      xs={fillHorizontal ? 12 : 6}
                      key={`${i}-` + field}
                      sx={{
                        textAlign: i % 2 == 0 ? 'left' : 'right',
                      }}
                    >
                      <ListItemText key={field}>
                        {!props.columns[field].hideMobile && (
                          <Grid item container xs={12}>
                            <RootineTableColumn {...props.columns[field]} />
                          </Grid>
                        )}
                        <Grid item container xs={12}>
                          <RootineTableRow {...row[field]} mobile={true} />
                        </Grid>
                      </ListItemText>
                    </Grid>
                  );
                })}
              </Grid>
            </ListItem>
          );
        })}
    </List>
  );
};
